import React from 'react';
import { PREMIUM_MOCKUP_IMAGE } from '../../data/site';
export function HeroMockup() {
  return <figure className="mx-auto w-full max-w-[300px] sm:max-w-[480px] lg:max-w-[560px]" data-id="element-131" data-mp="q0ar9wz7rgiu">
      <div className="overflow-hidden rounded-2xl border border-white/20 bg-white shadow-[0_24px_60px_-18px_rgba(0,0,0,0.5)]" data-id="element-132" data-mp="c95zfh237sj2">
        <img src={PREMIUM_MOCKUP_IMAGE} alt="Handball Class Ready digital pack illustrated as a premium box with the lesson guide and five bonus resources" width={1374} height={1145} fetchPriority="high" className="block h-auto w-full" data-id="element-133" data-mp="h6pf8lefodd4" />
      </div>
      <figcaption className="mt-3 text-center text-xs text-white/65 sm:text-sm" data-id="element-134" data-mp="3pgqxxi1ie1en">
        Digital PDF pack · Illustrative mockup · Nothing shipped
      </figcaption>
    </figure>;
}